// Hook reutilizable para gestionar la FE de una venta - Sprint 35.
import { useCallback, useEffect, useState } from 'react';
import {
  getFEByVenta, enviarFE, reenviarFE, abrirArchivoFE,
} from '../services/feService';

/**
 * Uso tipico:
 *   const { fe, loading, error, enviar, reenviar, verXml, verPdf, reload }
 *     = useFacturaElectronica(ventaId);
 */
export default function useFacturaElectronica(ventaId) {
  const [fe, setFe] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!ventaId) { setFe(null); return; }
    setLoading(true); setError(null);
    try {
      const data = await getFEByVenta(ventaId);
      setFe(data);
    } catch (e) {
      setError(e.message || 'Error cargando FE');
      setFe(null);
    } finally {
      setLoading(false);
    }
  }, [ventaId]);

  useEffect(() => { load(); }, [load]);

  const _accion = useCallback(async (fn) => {
    if (!fe) return null;
    setLoading(true); setError(null);
    try {
      const data = await fn(fe.id);
      setFe(data);
      return data;
    } catch (e) {
      setError(e.message || 'Error ejecutando accion');
      return null;
    } finally {
      setLoading(false);
    }
  }, [fe]);

  const enviar = useCallback(() => _accion(enviarFE), [_accion]);
  const reenviar = useCallback(() => _accion(reenviarFE), [_accion]);
  const verXml = useCallback(() => {
    if (!fe || !fe.xml_path) return;
    return abrirArchivoFE(fe.id, 'xml');
  }, [fe]);
  const verPdf = useCallback(() => {
    if (!fe || !fe.pdf_path) return;
    return abrirArchivoFE(fe.id, 'pdf');
  }, [fe]);

  return { fe, loading, error, enviar, reenviar, verXml, verPdf, reload: load };
}
